import { DateTime } from "luxon";
import { TooltipItem } from "chart.js";
import { getPointTime } from "./getPointTime";
import { DatasetDataItem } from "../types";

export const getTooltipTitle =
  (start?: number) => (tooltipItems: TooltipItem<"line">[]) => {
    const tooltipItem = tooltipItems[0];
    const { x: pointMinutes } = tooltipItem.raw as DatasetDataItem;

    const pointTime = getPointTime(pointMinutes, start);

    return pointTime.toLocaleString(DateTime.DATETIME_MED);
  };
